import {Endpoints} from '../../globals/api/endpoints';

export class CacheEndpoints extends Endpoints {
    public static readonly CACHE = CacheEndpoints.VIEWER + '/cache';

    public static readonly CACHE_DATES = CacheEndpoints.CACHE + '/dates';

}
